export const CALAMITY_KIND_DATA  = [{
    text : 'CALAMITY.CALAMITY_KIND.ACCIDENT'
    },
    {
    text : 'CALAMITY.CALAMITY_KIND.DISEASE_OUTBREAK'
    },
    {
    text : 'CALAMITY.CALAMITY_KIND.EPIDEMIC'
    },
    {
    text : 'CALAMITY.CALAMITY_KIND.NATURAL_DISASTER'
    },
    {
    text : 'CALAMITY.CALAMITY_KIND.PANDAMIC'
    },
    {
    text : 'CALAMITY.CALAMITY_KIND.TERRORISM'
    }]